<template>
  <div>
    <report-panel :anchor="anchor">
      <div slot="title">
        Sanctions<br />
        <span style="font-size: 12px; font-weight: 400"
          >Cases on HM Treasury's consolidated list of financial sanctions.
        </span>
      </div>
      <div slot="body">
        <table
          class="table table-striped"
          id="company-sanctions-table-ok"
          v-if="report.companyoverview.sanctions.length === 0"
        >
          <tr>
            <td colspan="3" style="text-align: center">
              <h6>No sanction matches found</h6>
              <p>
                Using the search
                <strong>{{ report.companyoverview.company_name }}</strong>
              </p>
            </td>
          </tr>
        </table>
        <table class="table table-striped" v-if="report.companyoverview.sanctions.length > 0">
          <tr>
            <td colspan="3" style="text-align: center">
              <h6 class="warning-heading">
                {{ report.companyoverview.sanctions.length }}
                <span v-if="report.companyoverview.sanctions.length > 1">
                  potential SANCTION matches found</span
                >
                <span v-if="report.companyoverview.sanctions.length === 1">
                  potential SANCTION match found</span
                >
              </h6>
              <p>
                Using the search
                <strong>{{ report.companyoverview.company_name }}</strong>
              </p>
            </td>
          </tr>
          <tr colspan="3">
            <td align="right" valign="bottom">
              <a
                data-toggle="collapse"
                href="#sanctions"
                class="accordion-toggle"
                aria-expanded="true"
                >Review Matches</a
              >
            </td>
          </tr>
        </table>
        <div id="sanctions" class="row collapse">
          <div class="col-xs-12">
            <table class="table table-striped" id="company-sanctions-table">
              <tbody v-for="sanction in report.companyoverview.sanctions" :key="sanction.id">
                <tr>
                  <th scope="row">Name:</th>
                  <td>{{ isEmptyMessage(sanction.name) }}</td>
                </tr>
                <tr>
                  <th scope="row">Address:</th>
                  <td>{{ isEmptyMessage(sanction.address) }}</td>
                </tr>
                <tr>
                  <th scope="row">Country:</th>
                  <td>{{ isEmptyMessage(sanction.country) }}</td>
                </tr>
                <tr>
                  <th scope="row">Regime:</th>
                  <td>{{ isEmptyMessage(sanction.regime) }}</td>
                </tr>
                <tr>
                  <th scope="row">Other Information:</th>
                  <td>{{ isEmptyMessage(sanction.other_information) }}</td>
                </tr>
                <tr>
                  <th scope="row">Listed on:</th>
                  <td>{{ isEmptyMessage(formatDate(sanction.listed_date)) }}</td>
                </tr>
                <tr>
                  <th scope="row">Last Updated:</th>
                  <td>{{ isEmptyMessage(formatDate(sanction.last_updated)) }}</td>
                </tr>
                <tr>
                  <td colspan="2">&nbsp;</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </report-panel>
  </div>
</template>

<script>
import toolsMixin from '@/components/reports/ToolsMixin';
import ReportPanel from '@/components/reports/components/ReportPanel';

export default {
  components: {
    ReportPanel,
  },
  mixins: [toolsMixin],
  props: ['report', 'showAnchor'],
  computed: {
    anchor() {
      if (this.showAnchor) {
        return '#about';
      }
      return '';
    },
  },
};
</script>

<style scoped>
.accordion-toggle:after {
  font-family: 'Glyphicons Halflings';
  margin-top: 2px;
  margin-left: 5px;
  content: '\E114';
  float: right;
  color: grey;
}

.accordion-toggle.collapsed:after {
  content: '\e080';
}

a {
  color: black;
}

a:hover {
  color: black;
}

.warning-heading {
  color: #e0741c;
  font-size: 120%;
}
</style>
